import styled from "styled-components/macro";

export const User = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 8px;
  transition: background 200ms;
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  opacity: ${({ isDisabled }) => (isDisabled ? "0.7" : "1")};

  &:hover {
    background: ${({ isDisabled }) =>
      isDisabled ? "none" : "rgba(255, 255, 255, 0.2)"};
  }

  &:active {
    transform: scale(0.98);
  }

  svg {
    margin-right: 8px;
  }
`;
